import { Outlet } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material/styles';
import { useRef } from 'react';

import usePageTracking from '@/hooks/usePageTracking';

function PublicLayout() {
	usePageTracking()

	const observedElementRef = useRef(null);

	const html = (
		<StyledEngineProvider injectFirst>
			<Outlet />
		</StyledEngineProvider>
	);

	return (
		<div ref={observedElementRef} className='w-full h-full'>
			{html}
		</div>
	);
}

export default PublicLayout;
